module.exports = __webpack_public_path__ + "img/CWM-WebsiteTiles-EOTAS-F01-Certificate-72dpi.9db46c70.jpg";